import { axiosInstanceV3 } from '@partiu/api/axios';
import { IBook, ReceivedBooks } from '@partiu/api/types';

export function saveBookProgress(book: IBook, progress: string = '0', position: string = '0') {
  localStorage.setItem('current-book', JSON.stringify(book));
  localStorage.setItem('current-book-progress', progress);
  localStorage.setItem(`${book.id}-position`, position);
}

export function getBookPosition(bookId: number) {
  return parseInt(localStorage.getItem(`${bookId}-position`) || '0');
}



export async function getReceivedByIdBook(bookId: number): Promise<ReceivedBooks | null> {
  try {
    const { data: books } = await axiosInstanceV3.get('bookstore/received-books/monthly-report/', {
      params: {
        book__id: bookId,
      },
    });

    if (!Array.isArray(books)) {
      return null;
    }

    // Find the received book that matches the bookId
    for (const receivedMonth of books) {
      if (!receivedMonth.books || !Array.isArray(receivedMonth.books)) {
        continue;
      }

      const foundReceivedBook = receivedMonth.books.find(
        (receivedBook: ReceivedBooks) => receivedBook.book?.id === bookId
      );

      if (foundReceivedBook) {
        return foundReceivedBook;
      }
    }

    return null;
  } catch (error) {
    console.error('Error fetching received book:', error);
    return null;
  }
}
